module.exports = __webpack_public_path__ + "static/media/mileage-odometer.36a9c949.svg";